import { render, staticRenderFns } from "./Xrays.vue?vue&type=template&id=aa3898c6&"
import script from "./Xrays.vue?vue&type=script&lang=js&"
export * from "./Xrays.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports